export default "__VITE_ASSET__CvBO2abB__"